export const common = {
  // Navigation
  'nav.features': 'Características',
  'nav.howItWorks': 'Cómo funciona',
  'nav.pricing': 'Precios',
  'nav.faq': 'FAQ',
  'nav.aboutUs': 'Sobre nosotros',
  'nav.getStarted': 'Comenzar',

  // About Us Section
  'aboutUs.badge': 'Sobre nosotros',
  'aboutUs.title': 'Sobre nosotros',
  'aboutUs.line1': 'Las ideas son baratas.',
  'aboutUs.line2': 'El capital no. El tiempo aún menos.',
  'aboutUs.paragraph1': 'IdeaOracle.ai fue fundado porque la mayoría de las ideas de negocio no fracasan por falta de coraje – sino por falta de honestidad. Demasiada validación. Muy poca realidad.',
  'aboutUs.belief1a': 'No creemos en el bombo.',
  'aboutUs.belief1b': 'Creemos en la lógica del mercado.',
  'aboutUs.belief2a': 'No creemos en la motivación.',
  'aboutUs.belief2b': 'Creemos en la demanda, la competencia y la diferenciación.',
  'aboutUs.mission1': 'Nuestra tarea no es hacer que las ideas se vean bien.',
  'aboutUs.mission2': 'Nuestra tarea es revelar su viabilidad.',
  'aboutUs.analysis': 'IdeaOracle.ai analiza nichos de negocio en mecánica estructural del mercado, demanda realista, intensidad competitiva y viabilidad. No emocional. No optimista. Sino sobrio.',
  'aboutUs.failure1': 'La mayoría de las ideas fracasan.',
  'aboutUs.failure2': 'No porque los fundadores sean incapaces –',
  'aboutUs.failure3': 'sino porque nadie fue lo suficientemente claro antes.',
  'aboutUs.clarity': 'Existimos para entregar esa claridad.',
  'aboutUs.value1': 'Incómodo.',
  'aboutUs.value2': 'Directo.',
  'aboutUs.value3': 'Consecuente.',
  'aboutUs.confirm': 'Si una idea tiene sustancia, la confirmamos.',
  'aboutUs.deny': 'Si no, también lo decimos.',
  'aboutUs.noApplause': 'Sin aplausos.',
  'aboutUs.noSugarcoating': 'Sin endulzar.',
  'aboutUs.noTheater': 'Sin teatro.',

  // Hero Section
  'hero.badge': 'IA de decisión para nichos de negocio',
  'hero.title1': 'Las ideas son baratas.',
  'hero.title2': 'Las malas decisiones no lo son.',
  'hero.subtitle': 'Una IA que evalúa tu nicho de negocio',
  'hero.subtitleLine2': 'antes de que inviertas.',
  'hero.cta': 'Verificar idea',
  'hero.ctaSecondary': 'Cómo funciona',
  'hero.stat1Value': '30',
  'hero.stat1Label': 'Créditos por solicitud',
  'hero.stat2Value': 'Desde 7',
  'hero.stat2Label': 'Niveles de calificación',
  'hero.stat3Value': '100%',
  'hero.stat3Label': 'Honesto y Privado',

  // Features Section
  'features.title1': 'Características potentes para',
  'features.title2': 'empresas',
  'features.title3': 'modernas',
  'features.honestVerdict.title': 'Veredicto honesto, no un puntaje hype',
  'features.honestVerdict.description': 'Veredictos bueno/medio/débil claros, respaldados por datos de mercado reales y análisis de competidores. Ninguna calificación 9/10 diseñada para halagar cada idea.',
  'features.fullJourney.title': 'Del test de idea al Builder Report',
  'features.fullJourney.description': 'Valida en el chat, profundiza en el análisis de mercado, exporta un Builder Report de 25–75 páginas con personas, finanzas, go-to-market y pitch deck.',
  'features.multilingual.title': '21 idiomas, datos de mercado locales',
  'features.multilingual.description': 'De la PYME suiza al fundador solo en São Paulo — la IA responde en tu idioma, con fuentes de tu mercado.',

  // How It Works
  'howItWorks.title': 'Cómo funciona',
  'howItWorks.subtitle': 'Cuatro pasos hacia la claridad sobre tu nicho de negocio.',
  'howItWorks.step1Title': 'Elige un plan',
  'howItWorks.step1Desc': 'Starter, Pro o Builder – dependiendo de la profundidad de tu revisión.',
  'howItWorks.step2Title': 'Pregunta a la IA',
  'howItWorks.step2Desc': 'Haz tus preguntas sobre el nicho. Cada solicitud cuesta 30 créditos.',
  'howItWorks.step3Title': 'Obtén un veredicto honesto',
  'howItWorks.step3Desc': 'La IA califica: Bueno, Promedio o Malo. Sin endulzar.',
  'howItWorks.step4Title': 'Toma una decisión',
  'howItWorks.step4Desc': 'Ahora sabes si vale la pena seguir adelante.',

  // Pricing
  'pricing.title': 'Precios',
  'pricing.subtitle': 'Elige el plan que se ajuste a la profundidad de tu revisión.',
  'pricing.yearlyDiscount': 'Suscripción anual:',
  'pricing.yearlyDiscountValue': '-20% de descuento',
  'pricing.perMonth': 'por mes',
  'pricing.selectPlan': 'Seleccionar plan',
  'pricing.mostPopular': 'Más popular',
  'pricing.footer': 'Todos los precios en CHF. Los créditos solo se deducen por respuestas exitosas de IA.',
  
  // Starter Plan
  'pricing.starter.name': 'Starter',
  'pricing.starter.description': 'Para pruebas de realidad iniciales.',
  'pricing.starter.credits': '2,500 créditos',
  'pricing.starter.feature1': 'Generar idea de nicho',
  'pricing.starter.feature2': 'Afinar nicho',
  'pricing.starter.feature3': 'Verificación de realidad del mercado',
  'pricing.starter.feature4': 'Evaluación de competencia',
  'pricing.starter.feature5': 'Evaluación de tiempo',
  'pricing.starter.feature6': 'Veredicto honesto',
  'pricing.starter.feature7': 'Sesiones privadas',
  'pricing.starter.feature8': 'Historial y exportación',

  // Pro Plan
  'pricing.pro.name': 'Pro',
  'pricing.pro.description': 'Para revisión más profunda.',
  'pricing.pro.credits': '5,000 créditos',
  'pricing.pro.feature1': 'Todas las características de Starter',
  'pricing.pro.feature2': 'Más créditos para revisión intensiva',
  'pricing.pro.feature3': 'Sugerencias de mejora',
  'pricing.pro.feature4': 'Nichos alternativos',
  'pricing.pro.feature5': 'Análisis de mercado detallado',
  'pricing.pro.feature6': 'Soporte prioritario',
  'pricing.pro.feature7': 'Filtros avanzados',
  'pricing.pro.feature8': 'Favoritos de sesión',

  // Builder Plan
  'pricing.builder.name': 'Builder',
  'pricing.builder.description': 'Idea → Briefing para desarrolladores.',
  'pricing.builder.credits': 'Créditos ilimitados',
  'pricing.builder.feature1': 'Todas las características Pro',
  'pricing.builder.feature2': 'Solicitudes de IA ilimitadas',
  'pricing.builder.feature3': 'Modo Builder: Briefing para desarrolladores',
  'pricing.builder.feature4': 'Descripción general del proyecto estructurado',
  'pricing.builder.feature5': 'Flujos de usuario y funciones principales',
  'pricing.builder.feature6': 'Notas técnicas',
  'pricing.builder.feature7': 'Definir no objetivos',
  'pricing.builder.feature8': 'Límite de tasa de uso justo',
  'pricing.builder.limitNote': 'Límite de uso justo',
  'pricing.monthlyReset': 'Reinicio mensual',

  // Modal
  'pricing.modal.selected': 'seleccionado',
  'pricing.modal.comingSoon': 'El registro y el procesamiento de pagos estarán disponibles pronto.',
  'pricing.modal.patience': 'Estamos trabajando para brindarte una experiencia segura y fluida. Por favor, ten paciencia.',
  'pricing.modal.understood': 'Entendido',

  // FAQ
  'faq.title': 'FAQ',
  'faq.subtitle': 'Respondido honesta y críticamente.',
  'faq.q1': '¿Qué hace concretamente IdeaOracle.ai?',
  'faq.a1': 'IdeaOracle.ai evalúa ideas de negocio y nichos en lógica de mercado, demanda real, competencia, diferenciación y viabilidad.\nSi hay sustancia, mostramos cómo puede afinarse estratégicamente.\nSi no, lo decimos.',
  'faq.q2': '¿También generáis ideas?',
  'faq.a2': 'Sí.\nPero no a ciegas.\nDesarrollamos enfoques bajo lógica de mercado – no por motivación o tendencias.',
  'faq.q3': '¿Optimizáis modelos de negocio?',
  'faq.a3': 'Sí – si existe potencial.\nNo pulimos ilusiones.\nHacemos conceptos viables más resistentes.',
  'faq.q4': '¿Qué os diferencia de otras herramientas de IA?',
  'faq.a4': 'Otras herramientas ofrecen inspiración.\nNosotros ofrecemos evaluación.\nEl enfoque está en el realismo, no en el entusiasmo.',
  'faq.q5': '¿Es una garantía de éxito?',
  'faq.a5': 'No.\nReducimos malas decisiones – no eliminamos el riesgo.',
  'faq.q6': '¿Para quién es IdeaOracle.ai?',
  'faq.a6': 'Fundadores antes del lanzamiento\nEmpresarios antes de la expansión\nSide-builders antes de invertir tiempo\nInversores antes de la evaluación\n\nEn resumen: Para personas que quieren claridad antes que capital.',
  'faq.q7': '¿Y si solo busco validación?',
  'faq.a7': 'Entonces IdeaOracle.ai no es la herramienta adecuada.',
  'faq.q8': '¿Qué tan honesto es el análisis?',
  'faq.a8': 'Tan honesto como los datos y la mecánica del mercado lo permiten.\nSin euforia. Sin contemplaciones.',
  'faq.q9': '¿Reemplazáis la investigación de mercado?',
  'faq.a9': 'No.\nSomos una evaluación previa estratégica – no un estudio de mercado completo.',
  'faq.q10': '¿Por qué tan intransigentes?',
  'faq.a10': 'Porque fracasar es caro.\nLa honestidad no.',

  // Footer
  'footer.description': 'Esta plataforma no te ayuda a sentirte bien, te ayuda a decidir correctamente.',
  'footer.product': 'Producto',
  'footer.aiAssistant': 'Asistente IA',
  'footer.howItWorks': 'Cómo funciona',
  'footer.pricing': 'Precios',
  'footer.faq': 'FAQ',
  'footer.legal': 'Legal',
  'footer.privacy': 'Privacidad',
  'footer.terms': 'Términos',
  'footer.imprint': 'Aviso legal',
  'footer.support': 'Soporte',
  'footer.contact': 'Contacto',
  'footer.documentation': 'Documentación',
  'footer.copyright': '© 2025 IdeaOracle.ai. Todos los derechos reservados.',

  // AI Assistant
  'aiAssistant.title': 'Asistente IA de nichos',
  'aiAssistant.subtitle': 'Preguntar sobre nichos',
  'aiAssistant.welcomeMessage': '¡Hola! Describe tu idea o pregúntame sobre un nicho. Te daré una evaluación clara y honesta.',
  'aiAssistant.demoResponse': 'Esto es una demostración. Para obtener evaluaciones reales de IA, regístrate y elige un plan.',
  'aiAssistant.placeholder': 'Describe tu idea...',

  // Header & Sidebar
  'dashboard.header.title': 'Panel',
  'dashboard.sidebar.overview': 'Resumen',
  'dashboard.sidebar.newAnalysis': 'Asistente IA',
  'dashboard.sidebar.history': 'Historial',
  'dashboard.sidebar.credits': 'Créditos',
  'dashboard.sidebar.settings': 'Configuración',

  // Dashboard Overview
  'dashboard.overview.welcome': 'Bienvenido de nuevo, {{name}}',
  'dashboard.overview.subtitle': 'Aquí tienes un resumen rápido de tu actividad',

  // Dashboard Stats
  'dashboard.stats.creditsRemaining': 'Créditos restantes',
  'dashboard.stats.totalAnalyses': 'Análisis totales',
  'dashboard.stats.goodRatings': 'Valoraciones positivas',
  'dashboard.stats.nextReset': 'Próximo reinicio en',
  'dashboard.stats.days': 'días',

  // Quick Actions
  'dashboard.quickActions.title': 'Acciones rápidas',
  'dashboard.quickActions.checkNewIdea': 'Verificar una idea',
  'dashboard.quickActions.checkNewIdeaDesc': 'Analizar una idea de negocio existente',
  'dashboard.quickActions.generateIdea': 'Generar una idea',
  'dashboard.quickActions.generateIdeaDesc': 'Encontrar un nuevo nicho rentable',
  'dashboard.quickActions.builderBriefing': 'Briefing Builder',
  'dashboard.quickActions.builderBriefingDesc': 'Convertir una idea en un briefing listo para desarrolladores',
  'dashboard.quickActions.premiumOnly': 'Solo Builder',

  // Chat Header
  'chat.title': 'Asistente IA de nichos',
  'chat.subtitle': 'Haz preguntas sobre nichos. Evalúo de forma crítica y honesta.',
  'chat.creditsLabel': 'Créditos',

  // Chat Welcome
  'chat.welcomeTitle': 'Bienvenido al Asistente IA de nichos',
  'chat.welcomeDesc': 'Describe tu idea o pregunta sobre un nicho. Lo evaluaré honestamente: Bueno, Promedio o Malo.',
  'chat.aiWelcome': '¡Hola! Describe tu idea o pregúntame sobre un nicho. Te daré una evaluación clara y honesta.',

  // Chat Suggestions
  'chat.suggestion1': 'Encuéntrame un nicho rentable.',
  'chat.suggestion2': 'Tengo una idea – evalúala honestamente.',
  'chat.suggestion3': '¿Qué nichos tienen potencial ahora?',
  'chat.suggestion4': 'Afina este nicho y hazlo más específico.',

  // Chat Actions
  'chat.newConversation': 'Nueva conversación',
  'chat.today': 'Hoy',
  'chat.yesterday': 'Ayer',
  'chat.thisWeek': 'Esta semana',
  'chat.thisMonth': 'Este mes',
  'chat.older': 'Más antiguo',
  'chat.messages': 'mensajes',
  'chat.renameConversation': 'Renombrar',
  'chat.deleteConversation': 'Eliminar',
  'chat.cancel': 'Cancelar',
  'chat.rename': 'Renombrar',
  'chat.delete': 'Eliminar',
  'chat.favorite': 'Añadir favorito',
  'chat.unfavorite': 'Quitar favorito',
  'chat.searchSessions': 'Buscar conversaciones...',
  'chat.noResults': 'No se encontraron resultados',
  'chat.noSessions': 'Aún no hay conversaciones',
  'chat.enterNewName': 'Introduce un nuevo nombre...',
  'chat.deleteConfirmMessage': '¿Estás seguro de que quieres eliminar esta conversación? Esta acción no se puede deshacer.',

  // Chat Input & Errors
  'chat.inputPlaceholder': 'Escribe tu pregunta… (cuesta 30 créditos)',
  'chat.send': 'Enviar',
  'chat.voice': 'Hablar',
  'chat.listeningPlaceholder': 'Estoy escuchando... Habla ahora.',
  'chat.stopListening': 'Detener grabación',
  'chat.recording': 'Grabando...',
  'chat.speechNotSupported': 'El reconocimiento de voz no es compatible con tu navegador.',
  'chat.microphonePermissionDenied': 'Se denegó el acceso al micrófono. Por favor, permite el acceso en la configuración de tu navegador.',
  'chat.errorNotEnoughCredits': 'No hay suficientes créditos. Por favor, actualiza tu plan o espera al próximo reinicio.',
  'chat.errorAiFailed': 'La respuesta de IA falló. No se dedujeron créditos.',
  'chat.errorRateLimit': 'Demasiadas solicitudes. Por favor, espera un momento.',

  // Ratings
  'rating.good': 'Bueno',
  'rating.medium': 'Promedio',
  'rating.bad': 'Malo',
  'rating.unknown': 'Desconocido',

  // Auth Page
  'auth.branding.headline1': 'No todas las ideas son buenas.',
  'auth.branding.headline2': 'Te lo decimos honestamente.',
  'auth.branding.subtitle': 'Una IA de decisión para nichos de negocio. Clara. Crítica. Sin endulzar.',
  'auth.benefits.privacy.title': '100% Privado',
  'auth.benefits.privacy.desc': 'Tus ideas permanecen completamente privadas y seguras.',
  'auth.benefits.honest.title': 'IA Honesta',
  'auth.benefits.honest.desc': 'Sin endulzar – solo feedback claro y crítico.',
  'auth.benefits.fast.title': 'Resultados Rápidos',
  'auth.benefits.fast.desc': 'Obtén claridad sobre tu nicho en minutos.',
  'auth.trust.users': 'Usuarios Activos',
  'auth.trust.ideas': 'Ideas Analizadas',
  'auth.trust.rating': 'Valoración',
  'auth.login.title': 'Iniciar Sesión',
  'auth.login.headline': 'Bienvenido de nuevo',
  'auth.login.subtitle': 'Inicia sesión para continuar tu viaje.',
  'auth.login.forgotPassword': '¿Olvidaste tu contraseña?',
  'auth.login.submit': 'Iniciar Sesión',
  'auth.login.noAccount': '¿No tienes cuenta?',
  'auth.login.signUp': 'Regístrate',
  'auth.register.title': 'Registrarse',
  'auth.register.headline': 'Crea tu cuenta',
  'auth.register.subtitle': 'Comienza a analizar tus ideas de negocio hoy.',
  'auth.register.submit': 'Crear Cuenta',
  'auth.register.hasAccount': '¿Ya tienes una cuenta?',
  'auth.register.signIn': 'Iniciar sesión',
  'auth.fields.name': 'Nombre Completo',
  'auth.fields.email': 'Correo Electrónico',
  'auth.fields.password': 'Contraseña',
  'auth.fields.confirmPassword': 'Confirmar Contraseña',
  'auth.fields.selectPlan': 'Selecciona tu plan',
  'auth.placeholders.name': 'Ingresa tu nombre',
  'auth.placeholders.email': 'Ingresa tu correo',
  'auth.placeholders.password': 'Ingresa tu contraseña',
  'auth.placeholders.confirmPassword': 'Confirma tu contraseña',
  'auth.terms.accept': 'Acepto los',
  'auth.terms.terms': 'Términos y Condiciones',
  'auth.privacy.accept': 'Acepto la',
  'auth.privacy.policy': 'Política de Privacidad',
  'auth.errors.nameRequired': 'El nombre es obligatorio',
  'auth.errors.emailRequired': 'El correo es obligatorio',
  'auth.errors.emailInvalid': 'Por favor ingresa un correo válido',
  'auth.errors.passwordRequired': 'La contraseña es obligatoria',
  'auth.errors.passwordLength': 'La contraseña debe tener al menos 8 caracteres',
  'auth.errors.passwordMismatch': 'Las contraseñas no coinciden',
  'auth.loading': 'Por favor espera...',
  'auth.or': 'o continuar con',
  'auth.social.google': 'Continuar con Google',
  'auth.social.apple': 'Continuar con Apple',

  // Dashboard (English fallback values — translators can replace later)
  'dashboard.header.tagline': 'Your AI Assistant',
  'dashboard.header.logout': 'Sign out',
  'dashboard.sidebar.dashboard': 'Dashboard',
  'dashboard.sidebar.subscription': 'Subscription & Billing',
  'dashboard.sidebar.plan': 'Plan',
  'dashboard.unlimited': 'Unlimited',
  'dashboard.upgrade': 'Upgrade',
  'dashboard.close': 'Close',
  'dashboard.backToOverview': 'Back to overview',
  'dashboard.overview.title': 'Overview',
  'dashboard.overview.last24Hours': 'Last 24 hours',
  'dashboard.overview.loadError': 'Failed to load overview',
  'dashboard.overview.plan': 'Plan',
  'dashboard.overview.unlimitedCredits': 'Unlimited credits available',
  'dashboard.overview.creditsAvailable': '{{formatted}} credits available',
  'dashboard.overview.creditsUsageThisMonth': 'Credit usage this month',
  'dashboard.overview.creditsAvailablePct': '{{pct}}% available',
  'dashboard.overview.recentActivity': 'Recent activity',
  'dashboard.overview.noActivity': 'No activity yet',
  'dashboard.overview.latestIdeas': 'Latest ideas',
  'dashboard.overview.noIdeas': 'No ideas analyzed yet',
  'dashboard.overview.stats.analysesToday': 'Analyses today',
  'dashboard.overview.stats.analysesTotal': 'Total analyses',
  'dashboard.overview.stats.successRate': 'Success rate',
  'dashboard.overview.stats.topRatings': 'Top ratings',
  'dashboard.overview.activity.nicheAnalysisComplete': 'Niche analysis completed',
  'dashboard.overview.activity.refund': 'Refund',
  'dashboard.overview.activity.payment': 'Payment',
  'dashboard.overview.time.justNow': 'just now',
  'dashboard.overview.time.minutesAgo': '{{count}} min ago',
  'dashboard.overview.time.hoursAgo': '{{count}} h ago',
  'dashboard.overview.time.daysAgo': '{{count}} days ago',
  'chat.ratingStrong': 'Strong',
  'chat.ratingMixed': 'Mixed',
  'chat.ratingWeak': 'Weak',
  'chat.loadIdeaError': 'Could not load idea',
  'chat.deleteError': 'Delete failed',
  'chat.notEnoughCreditsTitle': 'Not enough credits',
  'chat.currentBalance': 'Your current balance:',
  'chat.ai': 'AI',
  'chat.you': 'You',
  'dashboard.credits.title': 'Credit usage',
  'dashboard.credits.subtitle': 'Your current consumption',
  'dashboard.credits.loadError': 'Failed to load credits',
  'dashboard.credits.downgradePending': 'Downgrade is awaiting administrator approval.',
  'dashboard.credits.planUpdated': 'Plan updated successfully!',
  'dashboard.credits.planChangeFailed': 'Plan change failed',
  'dashboard.credits.planSuffix': 'Plan',
  'dashboard.credits.downgradeWaiting': 'Downgrade awaiting approval',
  'dashboard.credits.used': 'Used',
  'dashboard.credits.resetOn': 'Reset on {{date}}',
  'dashboard.credits.recentActivity': 'Recent activity',
  'dashboard.credits.noActivity': 'No activity yet',
  'dashboard.credits.currentPackage': 'Your current package',
  'dashboard.credits.chfPerMonth': 'CHF/month',
  'dashboard.credits.creditsPerMonth': '{{formatted}} credits/month',
  'dashboard.credits.perMonth': 'per month',
  'dashboard.credits.upgradePackage': 'Upgrade package',
  'dashboard.credits.changePlan': 'Change plan',
  'dashboard.credits.current': 'Current',
  'dashboard.credits.premium': 'Premium',
  'dashboard.credits.noPlans': 'No plans available.',
  'dashboard.credits.currentPlan': 'Current plan',
  'dashboard.credits.selected': 'Selected',
  'dashboard.credits.selectPlan': 'Select {{plan}}',
  'dashboard.credits.processing': 'Processing...',
  'dashboard.credits.switchPlan': 'Switch plan',
  'dashboard.credits.tx.deduction': 'Credits used',
  'dashboard.credits.tx.reset': 'Monthly reset',
  'dashboard.credits.tx.bonus': 'Bonus credits',
  'dashboard.credits.tx.refund': 'Refund',
  'dashboard.history.title': 'Idea history',
  'dashboard.history.loadError': 'Failed to load ideas',
  'dashboard.history.analysesCount': '{{count}} analyses',
  'dashboard.history.yourLatest': 'Your latest analyses',
  'dashboard.history.refresh': 'Refresh',
  'dashboard.history.exportAll': 'Export all',
  'dashboard.history.searchPlaceholder': 'Search ideas...',
  'dashboard.history.allRatings': 'All ratings',
  'dashboard.history.emptyTitle': 'No analyses yet',
  'dashboard.history.emptyDesc': 'Start a chat to evaluate your first business idea. Completed analyses will appear here automatically.',
  'dashboard.history.startFirstChat': 'Start your first chat',
  'dashboard.history.noMatchTitle': 'No results',
  'dashboard.history.noMatchDesc': 'No analysis matches your filter. Adjust your search or rating.',
  'dashboard.history.fullAnalysis': 'Full analysis',
  'dashboard.history.download': 'Download',
  'dashboard.history.saveAsJson': 'Save as JSON',
  'dashboard.history.saveAsTxt': 'Save as TXT',
  'dashboard.history.saveAsPdf': 'Save as PDF',
  'dashboard.history.deleteAnalysisTitle': 'Delete analysis?',
  'dashboard.history.actionIrreversible': 'This action cannot be undone.',
  'dashboard.history.deleteSuccess': 'Analysis deleted successfully',
  'dashboard.history.deleteError': 'Delete failed',
  'dashboard.history.jsonSuccess': 'JSON file downloaded successfully',
  'dashboard.history.txtSuccess': 'TXT file downloaded successfully',
  'dashboard.history.pdfSuccess': 'PDF file downloaded successfully',
  'dashboard.history.exportError': 'Export failed',
  'dashboard.history.allExportedAsJson': '{{count}} ideas exported as JSON',
  'dashboard.history.marketAnalysis': 'Market analysis',
  'dashboard.history.swotAnalysis': 'SWOT analysis',
  'dashboard.history.recommendations': 'Recommendations',
  'dashboard.history.actionRecommendations': 'Action recommendations',
  'dashboard.history.export.header': 'IDEA ANALYSIS EXPORT',
  'dashboard.history.export.title': 'Title',
  'dashboard.history.export.rating': 'Rating',
  'dashboard.history.export.date': 'Date',
  'dashboard.history.export.category': 'Category',
  'dashboard.history.export.targetAudience': 'Target audience',
  'dashboard.history.export.metrics': 'Metrics',
  'dashboard.history.export.summary': 'Summary',
  'dashboard.history.export.exportedOn': 'Exported on',
  'dashboard.history.pdf.header': 'Business idea analysis',
  'dashboard.history.metrics.marketSize': 'Market size',
  'dashboard.history.metrics.competition': 'Competition',
  'dashboard.history.metrics.startupCost': 'Startup cost',
  'dashboard.history.metrics.timeToMarket': 'Time to market',
  'dashboard.history.metrics.profitPotential': 'Profit potential',
  'dashboard.history.metrics.scalability': 'Scalability',
  'dashboard.history.swot.strengths': 'Strengths',
  'dashboard.history.swot.weaknesses': 'Weaknesses',
  'dashboard.history.swot.opportunities': 'Opportunities',
  'dashboard.history.swot.threats': 'Threats',
  'dashboard.settings.title': 'Settings',
  'dashboard.settings.subtitle': 'Manage your account and preferences',
  'dashboard.settings.loadError': 'Failed to load settings',
  'dashboard.settings.profileSaved': 'Profile saved successfully',
  'dashboard.settings.preferencesSaved': 'Preferences saved successfully',
  'dashboard.settings.notificationsSaved': 'Notification settings saved',
  'dashboard.settings.saveFailed': 'Save failed',
  'dashboard.settings.saving': 'Saving...',
  'dashboard.settings.saveChanges': 'Save changes',
  'dashboard.settings.deleting': 'Deleting...',
  'dashboard.settings.deleteConfirmKeyword': 'DELETE',
  'dashboard.settings.deleteAccountFailed': 'Account deletion failed',
  'dashboard.settings.dataExportSuccess': 'Data exported successfully',
  'dashboard.settings.tabs.profile': 'Profile',
  'dashboard.settings.tabs.preferences': 'Preferences',
  'dashboard.settings.tabs.notifications': 'Notifications',
  'dashboard.settings.tabs.account': 'Account & Subscription',
  'dashboard.settings.profile.name': 'Name',
  'dashboard.settings.profile.email': 'Email',
  'dashboard.settings.profile.phone': 'Phone',
  'dashboard.settings.profile.avatarNote': 'Profile picture can be configured via update URL',
  'dashboard.settings.preferences.language': 'Language',
  'dashboard.settings.preferences.timezone': 'Time zone',
  'dashboard.settings.preferences.currency': 'Currency',
  'dashboard.settings.notifications.emailTitle': 'Email notifications',
  'dashboard.settings.notifications.pushTitle': 'Push notifications',
  'dashboard.settings.notifications.emailAnalysis.title': 'Analysis complete',
  'dashboard.settings.notifications.emailAnalysis.desc': 'Receive an email when your analysis is ready',
  'dashboard.settings.notifications.emailCredits.title': 'Credit updates',
  'dashboard.settings.notifications.emailCredits.desc': 'Notifications about credits and resets',
  'dashboard.settings.notifications.emailBilling.title': 'Invoices & payments',
  'dashboard.settings.notifications.emailBilling.desc': 'Notifications about invoices and subscription changes',
  'dashboard.settings.notifications.emailNewsletter.title': 'Newsletter',
  'dashboard.settings.notifications.emailNewsletter.desc': 'Tips, updates and new features',
  'dashboard.settings.notifications.pushAnalysis.title': 'Analysis complete',
  'dashboard.settings.notifications.pushAnalysis.desc': 'Browser notification when analysis is complete',
  'dashboard.settings.notifications.pushCredits.title': 'Credit warnings',
  'dashboard.settings.notifications.pushCredits.desc': 'Warning for low credit balance',
  'dashboard.settings.account.currentPlan': 'Current subscription',
  'dashboard.settings.account.plan': 'Plan',
  'dashboard.settings.account.price': 'Price',
  'dashboard.settings.account.moAbbrev': 'mo',
  'dashboard.settings.account.nextBilling': 'Next billing',
  'dashboard.settings.account.manageSubscription': 'Manage subscription & payments',
  'dashboard.settings.privacy.title': 'Data & privacy',
  'dashboard.settings.privacy.exportData': 'Export data',
  'dashboard.settings.privacy.deleteAccount': 'Delete account',
  'dashboard.settings.deleteModal.title': 'Delete account?',
  'dashboard.settings.deleteModal.subtitle': 'All data will be permanently deleted.',
  'dashboard.settings.deleteModal.point1': 'All analyses and data will be deleted',
  'dashboard.settings.deleteModal.point2': 'Active subscription will be cancelled immediately',
  'dashboard.settings.deleteModal.point3': 'No refunds possible',
  'dashboard.settings.deleteModal.typeKeyword': 'Type "{{keyword}}" *',
  'dashboard.subscription.title': 'Subscription & Billing',
  'dashboard.subscription.subtitle': 'Manage your subscription and invoices',
  'dashboard.subscription.loadError': 'Failed to load subscription',
  'dashboard.subscription.cancelKeyword': 'CANCEL',
  'dashboard.subscription.cancelSuccess': 'Your subscription has been cancelled at the end of the billing period.',
  'dashboard.subscription.cancelFailed': 'Cancellation failed',
  'dashboard.subscription.reactivate': 'Reactivate',
  'dashboard.subscription.reactivateSuccess': 'Your subscription was reactivated successfully!',
  'dashboard.subscription.reactivateFailed': 'Reactivation failed',
  'dashboard.subscription.pauseSuccess': 'Your subscription has been paused.',
  'dashboard.subscription.pauseFailed': 'Pause failed',
  'dashboard.subscription.downgradePending': 'Downgrade is awaiting administrator approval.',
  'dashboard.subscription.downgradeRequested': 'Downgrade request submitted.',
  'dashboard.subscription.planChangedTo': 'Plan successfully changed to {{plan}}!',
  'dashboard.subscription.newPlan': 'new plan',
  'dashboard.subscription.planChangeFailed': 'Plan change failed',
  'dashboard.subscription.tabs.overview': 'Overview',
  'dashboard.subscription.tabs.billing': 'Billing address',
  'dashboard.subscription.tabs.history': 'Payment history',
  'dashboard.subscription.status.active': 'active',
  'dashboard.subscription.status.cancelled': 'cancelled',
  'dashboard.subscription.status.paused': 'paused',
  'dashboard.subscription.status.overdue': 'overdue',
  'dashboard.subscription.status.label': 'Status',
  'dashboard.subscription.memberSince': 'Member since {{date}}',
  'dashboard.subscription.chfBase': 'CHF {{amount}} base',
  'dashboard.subscription.monthAbbrev': 'month',
  'dashboard.subscription.creditsPerMonth': 'Credits / month',
  'dashboard.subscription.freeAccount': 'Free account',
  'dashboard.subscription.cancelSubscription': 'Cancel subscription',
  'dashboard.subscription.downloadInvoices': 'Download invoices',
  'dashboard.subscription.invoicesAvailable': '{{count}} invoices available as PDF',
  'dashboard.subscription.accountSettings': 'Account settings',
  'dashboard.subscription.accountSettingsDesc': 'Profile, notifications & more',
  'dashboard.subscription.billing.recipient': 'Billing recipient',
  'dashboard.subscription.billing.addressNote': 'Address changes are currently only available in your profile.',
  'dashboard.subscription.history.title': 'Payment history',
  'dashboard.subscription.history.subtitle': 'Download all invoices as PDF',
  'dashboard.subscription.history.downloadAll': 'Download all',
  'dashboard.subscription.history.eurNote': 'Invoices are always issued in CHF. EUR amounts shown are for reference only.',
  'dashboard.subscription.history.noInvoices': 'No invoices yet',
  'dashboard.subscription.history.col.date': 'Date',
  'dashboard.subscription.history.col.type': 'Type',
  'dashboard.subscription.history.col.net': 'Net',
  'dashboard.subscription.history.col.vat': 'VAT',
  'dashboard.subscription.history.col.total': 'Total',
  'dashboard.subscription.history.col.pdf': 'PDF',
  'dashboard.subscription.history.invoicesCount': '{{count}} invoices',
  'dashboard.subscription.history.totalAmount': 'Total amount',
  'dashboard.subscription.switching': 'Switching...',
  'dashboard.subscription.cancelling': 'Cancelling...',
  'dashboard.subscription.cancelNow': 'Cancel now',
  'dashboard.subscription.eurNotice.prefix': 'Prices are displayed in',
  'dashboard.subscription.eurNotice.currency': 'Euro',
  'dashboard.subscription.eurNotice.suffix': '',
  'dashboard.subscription.eurNotice.rate': 'Rate',
  'dashboard.subscription.eurNotice.currentRate': 'Current rate',
  'dashboard.subscription.eurChangePlanNote': 'Prices shown in EUR ({{note}}). Billing is in CHF.',
  'dashboard.subscription.cancelModal.title': 'Cancel subscription?',
  'dashboard.subscription.cancelModal.subtitle': 'Cancellation takes effect at the end of the billing period.',
  'dashboard.subscription.cancelModal.point1': 'No more credits after expiration',
  'dashboard.subscription.cancelModal.point2': 'Premium features will be removed',
  'dashboard.subscription.cancelModal.pauseTitle': 'Alternative: Pause subscription?',
  'dashboard.subscription.cancelModal.pauseDesc': 'Pause your subscription instead and keep your data.',
  'dashboard.subscription.cancelModal.pauseCta': 'Pause instead',
  'dashboard.subscription.cancelModal.reasonLabel': 'Cancellation reason',
  'dashboard.subscription.cancelModal.selectReason': 'Please select...',
  'dashboard.subscription.cancelModal.reasonTooExpensive': 'Too expensive',
  'dashboard.subscription.cancelModal.reasonNotUsing': 'Not using it enough',
  'dashboard.subscription.cancelModal.reasonMissing': 'Missing features',
  'dashboard.subscription.cancelModal.reasonAlternative': 'Found alternative',
  'dashboard.subscription.cancelModal.reasonOther': 'Other',
  'dashboard.subscription.cancelModal.confirmLabel': 'Confirmation: Type "{{keyword}}" *',
  'dashboard.subscription.invoice.heading': 'INVOICE',
  'dashboard.subscription.invoice.from': 'FROM',
  'dashboard.subscription.invoice.to': 'TO',
  'dashboard.subscription.invoice.vatId': 'VAT ID',
  'dashboard.subscription.invoice.date': 'Invoice date',
  'dashboard.subscription.invoice.number': 'Invoice number',
  'dashboard.subscription.invoice.paymentStatus': 'Payment status',
  'dashboard.subscription.invoice.description': 'DESCRIPTION',
  'dashboard.subscription.invoice.quantity': 'QTY',
  'dashboard.subscription.invoice.price': 'PRICE',
  'dashboard.subscription.invoice.amount': 'AMOUNT',
  'dashboard.subscription.invoice.subscriptionLabel': 'Subscription',
  'dashboard.subscription.invoice.subtotal': 'Subtotal',
  'dashboard.subscription.invoice.total': 'Total amount',
  'dashboard.subscription.invoice.downloaded': 'Invoice {{invoiceNo}} downloaded!',
  'dashboard.subscription.invoice.pdfError': 'Failed to create PDF.',

  // Trial Plan
  'pricing.trial.name': 'Trial',
  'pricing.trial.description': 'Acceso gratuito de 3 días',
  'pricing.trial.credits': '250 créditos',
  'pricing.trial.free': 'Gratis',
  'pricing.trial.duration': 'Sin cargo durante 3 días',
  'pricing.trial.cta': 'Empezar prueba gratuita',
  'pricing.trial.feature1': '250 créditos para probar la IA',
  'pricing.trial.feature2': 'Acceso completo durante 3 días',
  'pricing.trial.feature3': 'No se requiere tarjeta de crédito',
  'pricing.trial.feature4': 'Cancela cuando quieras',

  // Gold Package
  'pricing.gold.name': 'Gold',
  'pricing.gold.description': '10.000 créditos + informe Builder de 25 páginas',
  'pricing.gold.credits': '10.000 créditos',
  'pricing.gold.feature1': '10.000 créditos',
  'pricing.gold.feature2': 'Informe Builder de 25 páginas',
  'pricing.gold.feature3': 'Todas las funciones de Starter y Pro',
  'pricing.gold.feature4': 'Análisis de mercado y resumen',
  'pricing.gold.feature5': 'Oportunidades, riesgos, recomendaciones',
  'pricing.gold.feature6': 'Descargar PDF',
  'pricing.gold.feature7': 'Soporte',

  // Platinum Package
  'pricing.platinum.name': 'Platinum',
  'pricing.platinum.description': '15.000 créditos + informe Builder de 100 páginas',
  'pricing.platinum.credits': '15.000 créditos',
  'pricing.platinum.feature1': '15.000 créditos',
  'pricing.platinum.feature2': 'Informe Builder de 100 páginas',
  'pricing.platinum.feature3': 'Todas las funciones de Gold',
  'pricing.platinum.feature4': 'Modo Builder: briefings para desarrolladores',
  'pricing.platinum.feature5': 'Resumen estructurado',
  'pricing.platinum.feature6': 'Análisis de mercado avanzado',
  'pricing.platinum.feature7': 'Soporte',

  // Pricing UI
  'pricing.monthly': 'Mensual',
  'pricing.yearly': 'Anual',
  'pricing.savings': 'ahorro',
  'pricing.billedYearly': 'Facturación anual',

  // Hero trial CTA
  'hero.trialTitle': 'Comienza tu prueba gratuita',
  'hero.creditsLabel': 'Créditos',
  'hero.trialTagline': 'Prueba nuestro asistente de IA gratis durante 3 días',
  'hero.trialCta': 'Regístrate y obtén 250 créditos',
  'hero.trialNoCard': 'No se requiere tarjeta de crédito. Sin compromiso.',

  // Admin
  'admin.dashboard.tabs.plans': 'Planes',

  // Credit top-up
  'dashboard.credits.topup.button': 'Recargar créditos',
  'dashboard.credits.topup.buttonTitle': 'Compra más créditos sin cambiar de plan',
  'dashboard.credits.topup.title': 'Recargar créditos',
  'dashboard.credits.topup.subtitle': 'CHF 0,15 por crédito — sin cambio de plan',
  'dashboard.credits.topup.quickAmounts': 'Selección rápida',
  'dashboard.credits.topup.custom': 'Personalizado',
  'dashboard.credits.topup.totalLabel': 'Total',
  'dashboard.credits.topup.creditsLabel': 'Créditos',
  'dashboard.credits.topup.confirm': 'Comprar ahora',
  'footer.disclaimer': 'Aviso legal',
  'legal.backToHome': 'Volver al inicio',
  'legal.lastUpdated': 'Última actualización',
  'legal.allRightsReserved': 'Todos los derechos reservados.',
  'legal.authoritativeNotice': 'Aún no hay una versión localizada en tu idioma. A continuación se muestra el texto autoritativo en inglés.',
  'legal.translationNotice': 'Esta es una traducción de cortesía. La versión inglesa es el original jurídicamente vinculante.',
};

export default common;
